import React from "react";
import CustomTabsGrid from "components/CustomTabs/CustomTabsGrid.js";
import Tracuuhoatdong from "components/Tracuuthongtin/Tracuuhoatdong.js";
import Thongtindoanhnghiep from "components/Tracuuthongtin/Thongtindoanhnghiep.js";
export default function Tracuu() {
  return (
    <div>
      <CustomTabsGrid
        headerColor="primary"
        tabs={[
          {
            tabName: "Tra cứu hoạt động",
            tabContent: <Tracuuhoatdong />,
          },
          {
            tabName: "Thông tin doanh nghiệp",
            tabContent: <Thongtindoanhnghiep />,
          },
        ]}
      />
    </div>
  );
}
